import { FC, useRef } from 'react';

import { IcImagePlus32Icon } from '@gem/icons';
import { IconView } from '@gem/ui-kit';

import { useUploadButtonPresenter } from './UploadButton.presenter';
import styles from './UploadButton.styles.m.css';

interface IUploadButtonProps {
  className?: string;
  onSelectFile: (file: File) => void;
}

const ACCEPTED_BACKGROUND_FORMATS = 'image/jpeg,image/png,image/jpg';

export const UploadButton: FC<IUploadButtonProps> = ({ className, onSelectFile }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const presenter = useUploadButtonPresenter({ inputRef, onSelectFile });

  return (
    <div
      className={className}
      onClick={presenter.onClick}
    >
      <IconView
        className={styles.icon}
        Icon={IcImagePlus32Icon}
      />
      <input
        ref={inputRef}
        onChange={presenter.onChange}
        className={styles.input}
        accept={ACCEPTED_BACKGROUND_FORMATS}
        type="file"
      />
    </div>
  );
};
